
import { defineComponent, nextTick } from "vue";
import ToolTip from "./ToolTip.vue";
import routesPath from "@/config/routesPath";
import common from "@/config/common";

export default defineComponent({
  name: "AppFooter",
  props: {
    saveBtnTxt: String,
    selectedSavedCardId: { type: Number, default: -1 },
    isFormInvalid: { type: Boolean, default: false },
    isSubmitDisabled: { type: Boolean, default: false },
    toolTip: { type: String, default: "" },
  },
  data() {
    return {
      routesPath,
      showTooltip: false,
    };
  },
  methods: {
    submitHandler() {
      this.$emit("submitHandler");
    },
    backButtonHandler() {
      const enrollment = JSON.parse(
        sessionStorage.getItem(common.storageVariables.enrollment) || "{}"
      );
      const totalEnrollments =
        Number(sessionStorage.getItem(common.storageVariables.enrollments)) ||
        0;
      // Special case: go back to enrollments if on profileInformation and conditions match
      if (
        enrollment?.serviceType === 1 &&
        totalEnrollments > 1 &&
        this.$route.name === routesPath.profileInformation
      ) {
        this.$router.push({ name: routesPath.enrollments });
        return;
      }
      const allRoutes = common.allRoutes;
      const currentRoute = allRoutes.find(
        (route) => route.link === this.$route.name
      );
      if (currentRoute) {
        const backPriority = currentRoute.priority - 1;
        const backRoute = allRoutes.find(
          (route) => route.priority === backPriority
        );
        let backRouteLink = backRoute?.link;
        if (currentRoute.link === routesPath.confirmation) {
          const allBenefitsWaived = sessionStorage.getItem(
            common.storageVariables.allBenefitsWaived
          );
          if (allBenefitsWaived === "true") {
            backRouteLink = routesPath.benefits;
          }
        }
        this.$router.push({ name: backRouteLink });
      }
    },
    showBackButton() {
      const enrollment = JSON.parse(
        sessionStorage.getItem(common.storageVariables.enrollment) || "{}"
      );
      const totalEnrollments =
        Number(sessionStorage.getItem(common.storageVariables.enrollments)) ||
        0;
      if (
        enrollment?.serviceType === 1 &&
        totalEnrollments > 1 &&
        this.$route.name === routesPath.profileInformation
      ) {
        return true;
      }
      return this.$route.name !== routesPath.profileInformation;
    },
  },
  components: { ToolTip },
});
